import { useEffect, useReducer } from "react";
import styled from "styled-components";
import { ParagraphTextColor, primaryFont, HeaderTextColor } from "utils";
import "./styles.scss";
import { Logo } from "assets/logos";
import { reducer, actions, initialState } from "./reducer";
import { BsFacebook, BsInstagram } from "react-icons/bs";
import { callApi } from "api";
import { BiPhoneCall } from "react-icons/bi";
import { MdMailOutline } from "react-icons/md";
import { PrimaryButton, SecondaryButton } from "components/Buttons";
import { useHistory } from "react-router-dom";
const Container = styled.div`
  background-color: ${(props) => props.theme.footer.background};
  p {
    color: ${(props) => props.theme.footer.color};
    font-family: ${primaryFont};
  }
  .footer__list__title {
    h1 {
      border-bottom: 3px solid ${(props) => props.theme.footer.border};
      color: ${(props) => props.theme.footer.color};
    }
  }
`;
const ContainerBottom = styled.div`
  background-color: ${(props) => props.theme.footer.bottom.background};
`;
export const Footer = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const history = useHistory();
  useEffect(() => {
    callApi(
      "/api/branchOffices/get/",
      "GET",
      {},
      {
        REQUEST: actions.GET_OFFICE_BRANCHES_REQUEST,
        SUCCESS: actions.GET_OFFICE_BRANCHES_SUCCESS,
        FAILURE: actions.GET_OFFICE_BRANCHES_FAILURE,
      },
      dispatch
    );
  }, []);
  return (
    <>
      <Container className="footer">
        <div className="footer__left">
          <div className="footer__logo__container">
            <img src={Logo} alt="Odessa Turismo" />
          </div>
          <div className="footer__info">
            <ParagraphTextColor>
              OdessaTurismo, es una agencia de viajes confiable, brindando sus
              servicios desde el 09 de septiembre de 1979, enfocada en la venta
              de boletos de avión, paquetes y circuitos nacionales e
              internacionales, siempre ofreciendo las mejores opciones de viaje.
            </ParagraphTextColor>
          </div>
        </div>

        <div className="footer__middle">
          <div className="footer__list__group">
            <div className="footer__list">
              <div className="footer__list__title">
                <HeaderTextColor modifiers={["h5"]}>
                  Nuestras Redes Sociales
                </HeaderTextColor>
              </div>
              <div className="footer__list__items footer__socials">
                <a
                  href="https://www.facebook.com/OdessaTurismo/"
                  target="_blank"
                >
                  <BsFacebook style={{ backgroundColor: "#3b5998" }} />
                </a>
                <a
                  href="https://www.instagram.com/odessaturismo/"
                  target="_blank"
                >
                  <BsInstagram style={{ backgroundColor: "#e4405f" }} />
                </a>
              </div>
            </div>

            <div className="footer__list">
              <div className="footer__list__title">
                <HeaderTextColor modifiers={["h5"]}>
                  Contacta con nosotros
                </HeaderTextColor>
              </div>
              {state.getOfficeBranches.loading ? (
                <ParagraphTextColor>Cargando...</ParagraphTextColor>
              ) : (
                <>
                  {state.getOfficeBranches.data?.map((branch) => (
                    <div className="footer__list__items" key={branch.id}>
                      <ParagraphTextColor>
                        {branch.name} - {branch.address}
                      </ParagraphTextColor>
                      <ParagraphTextColor>
                        <MdMailOutline />
                        <a href={`mailto:${branch.email}`}>{branch.email}</a>
                      </ParagraphTextColor>
                      <PrimaryButton
                        modifiers={["small"]}
                        onClick={() => {
                          window.open(`tel:${branch.phone}`);
                        }}
                      >
                        <BiPhoneCall />
                        <span>{branch.phone}</span>
                      </PrimaryButton>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
      <ContainerBottom className="footer__bottom">
        Copyright @{new Date().getFullYear()} Odessa Turismo | {"  "}
        <p
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            history.push("/privacidad");
          }}
        >
          Aviso de Privacidad
        </p>
      </ContainerBottom>
    </>
  );
};
